const ITEMS = [
  "Cinematography",
  "Luxury Weddings",
  "Editorial Portraits",
  "Documentary Films",
  "Travel Stories",
  "Ansh Agarwal Films",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-ivory/10 bg-coal/60 py-5 overflow-hidden select-none"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
          {ITEMS.map((item, i) => (
            <span key={`${half}-${i}`} className="flex items-center">
              <span className="font-display uppercase tracking-[0.45em] text-sm text-ivory/40 px-8 whitespace-nowrap">
                {item}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-amber/50 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
